import { turnout as turnoutService } from '../../services';

export const ActionTypes = {
  SET_VOTER_TURNOUT_DATA: 'SET_VOTER_TURNOUT_DATA',
  API_ERROR: 'API_ERROR',
};

/**
 * @description action creator for getting all voter turnout data
 */
export const getAllVoterTurnoutData = () => {
  return async (dispatch) => {
    try {
      const data = await turnoutService.fetchAll();
      dispatch({ type: ActionTypes.SET_VOTER_TURNOUT_DATA, payload: data });
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: ActionTypes.SET_VOTER_TURNOUT_DATA,
          error,
        },
      });
    }
  };
};
